import React, { useState, useEffect } from "react";
import presidentImage from "../src/assets/SS_President.png";
import ssp1 from "../src/assets/ssp.png";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./Menu1.css";

const PresidentsMessage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false); // Close sidebar when switching to desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Responsive styles with reduced gaps
  const styles = {
    card: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "center" : "flex-start",
      padding: isMobile ? "10px" : "15px",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      background: "linear-gradient(90deg, #fff, #cb71ca)",
      maxWidth: isMobile ? "98%" : "980px",
      margin: isMobile ? "5px auto" : "5px auto",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.6",
      marginTop: "5px"
    },
    imageContainer: {
      marginRight: isMobile ? "0" : "15px",
      marginBottom: isMobile ? "10px" : "0",
      flexShrink: 0,
      textAlign: isMobile ? "center" : "left",
    },
    image: {
      width: isMobile ? "90px" : "110px",
      height: isMobile ? "90px" : "110px",
      borderRadius: "50%",
      objectFit: "cover",
    },
    content: {
      flexGrow: 1,
      textAlign: isMobile ? "center" : "left",
    },
    heading: {
      marginBottom: "8px",
      color: "#700d69", // Purple color
      fontSize: isMobile ? "1.1rem" : "1.4rem",
      fontWeight: "bold",
      textAlign: isMobile ? "center" : "left",
    },
    text: {
      color: "#333",
      fontSize: isMobile ? "0.85rem" : "0.95rem",
      textAlign: "justify",
      marginBottom: isMobile ? "8px" : "10px",
    },
    bannerImage: {
      width: "100%",
      height: isMobile ? "180px" : "320px",
      objectFit: "cover",
    },
  };

  return (
    <div>
      <Navbar/>
      
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <div className="mobile-menu-toggle" onClick={toggleSidebar}>
          <div className={`hamburger ${sidebarOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
      )}

      <div className={`small-container ${isMobile ? 'mobile' : ''}`}>
        {/* Sidebar */}
        <div className={`small-sidebar ${isMobile ? (sidebarOpen ? 'mobile-open' : 'mobile-closed') : ''}`}>
          {/* Top wave */}
          <div className="sidebar-wave-top"></div>
          <ul>
            <li>
              <a href="presidents_message" onClick={isMobile ? closeSidebar : undefined}>President's Message</a>
            </li>
            <li><a href="documents" onClick={isMobile ? closeSidebar : undefined}>Annual Report</a></li>
            <li><a href="interest" onClick={isMobile ? closeSidebar : undefined}>Interest Rate</a></li>
            <li><a href="loans" onClick={isMobile ? closeSidebar : undefined}>Loans</a></li>
            <li><a href="awards" onClick={isMobile ? closeSidebar : undefined}>Awards</a></li>
          </ul>
          {/* Bottom wave */}
          <div className="sidebar-wave"></div>
        </div>

        {/* Content Section */}
        <div className="small-content">
          <div className="image-wrapper">
            <img 
              src={ssp1} 
              alt="About Us" 
              style={styles.bannerImage}
            />
          </div>
        </div>
      </div>

      <div style={styles.card}>
        {/* Image Section */}
        <div style={styles.imageContainer}>
          <img
            src={presidentImage}
            alt="President"
            style={styles.image}
          />
        </div>

        {/* Content Section */}
        <div style={styles.content}>
          <h2 style={styles.heading}>President's Message</h2>
          <p style={styles.text}>
            It is with great pleasure that I address this message to you on behalf
            of Shri Saraswathi Credit Souharda Sahakari Ltd. Puttur D. K.
          </p>
          <p style={styles.text}>
            The Co-Operative movement is having historical background in India. It
            is the root of Indian life. Co-Operatives are for all class of people.
            Further, it was always champion of the disadvantaged in the society.
            Today credit societies play an important role in economic as well as
            social development of the country. Apart from that they are promoting
            development and to fulfill the concept of financial inclusion.
          </p>
          <p style={styles.text}>
            Shri Saraswathi Credit Souharda Sahakari strongly believes in
            Co-Operative principles for the welfare of its members and strives to
            render various financial services under one roof and to become
            financial super market, where in all financial needs of the people are
            fulfilled. Thanks to our large number of members for their continued
            support for the growth of the Sahakari. We expect the same in future
            too.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default PresidentsMessage;